import { GridColDef, GridSortModel } from "@mui/x-data-grid";
import DescriptionCell from "../../componentes/fluxo-engenheiro/Requests/columns/descriptionCell";
import PartNumberCell from "../../componentes/fluxo-engenheiro/Requests/columns/partNumberCell";
import formatDateGrid from "../../utils/formatDateGrid";

export type CommonDeps = {
  sortModel: GridSortModel;
  onOpenDescription: (desc: string) => void; // callback enviado pela página (vai setIsModalOpen + setDescription)
  ascIcon: string;
  descIcon: string;
  onTap: (field: string) => void;
};

export const getCommonColumns = ({
  sortModel,
  onOpenDescription,
  ascIcon,
  descIcon,
  onTap,
}: CommonDeps): GridColDef[] => {
  const getSortDirectionByField = (field: string) =>
    sortModel.find((item) => item.field === field)?.sort;

  const renderSortButton = (field: string, label: string) => (
    <button
      type="button"
      aria-label={`Ordenar por ${label}`}
      onClick={() => onTap(field)}
    >
      <img
        alt=""
        className="iconEdit"
        src={getSortDirectionByField(field) === "asc" ? ascIcon : descIcon}
      />
    </button>
  );

  const renderDateColumn = (
    field: string,
    titleLines: [string, string],
    label: string,
  ): GridColDef => ({
    field,
    headerClassName: "header-table",
    renderHeader: () => (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
          }}
        >
          {titleLines.map((title) => (
            <b className="title-table" key={title}>
              {title}
            </b>
          ))}
        </div>
        <div>{renderSortButton(field, label)}</div>
      </div>
    ),
    flex: 0.7,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => (
      <div className="descriptionText">{formatDateGrid(params.value)}</div>
    ),
  });

  return [
    {
      field: "partNumber",
      headerClassName: "header-table",
      renderHeader: () => <b className="partNumberColluns"> Part Number </b>,
      renderCell: (params) => <PartNumberCell value={params.value as string} />,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "description",
      headerClassName: "header-table",
      renderHeader: () => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <b className="descriptionColluns">Descrição</b>
          {renderSortButton("description", "Descrição")}
        </div>
      ),
      renderCell: (params) => (
        <DescriptionCell
          value={params.value}
          onViewMore={(desc: string) => onOpenDescription(desc)}
        />
      ),
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    renderDateColumn(
      "classificationCreateDate",
      ["Data de", "Entrada"],
      "Data de Entrada",
    ),
    renderDateColumn(
      "classificationQuizFinishDate",
      ["Data Final", "do Laudo"],
      "Data Final do Laudo",
    ),
    renderDateColumn(
      "classificationApprovalDate",
      ["Data de", "Aprovação"],
      "Data de Aprovação",
    ),
    {
      field: "center",
      headerClassName: "header-table",
      renderHeader: () => <b className="flagColluns">Centro</b>,
      flex: 0.6,
      headerAlign: "left",
      align: "left",
      renderCell: (params) =>
        params.row.center ? (
          <span>{params.row.center}</span>
        ) : (
          <div className="centerText">N/A</div>
        ),
    },
  ];
};
